import axios from 'axios'
// import router from '@/router'
// import store from '@/store'

const baseURL = window.APP_CONFIG.BASE_URL
console.log(window.APP_CONFIG.BASE_URL, 'window.APP_CONFIG.BASE_URL')
const service = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 30 * 1000 // request timeout
})

service.interceptors.request.use(
config => {
  return config
},
error => {
  Promise.reject(error)
}
)
// respone interceptor
service.interceptors.response.use(
response => {
  return response
},
error => {
  return Promise.reject(error)
}
)

export default service
